// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__2deBU","label":"Category_label__2PJHx","content":"Category_content__g7sJV","header":"Category_header__mLg5Z","location":"Category_location__1ALZG"};